import React from 'react';
import ReactDOM from 'react-dom/client';
import Routess from './pathes'; 
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
    <div className='body'>
    <Routess />
    </div>
  </React.StrictMode>
  
);
